import React, { useEffect } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { dictionary } from '../../../dictionary';

const InvoicePay = ({
  conversion,
  espCostNet,
  netPaid1Invoice,
  netPaid2Invoice,
  netPaid,
  setNetPaid,
  netPaidEUR,
  setNetPaidEUR,
  grossPaid,
  setGrossPaid,
  grossPaidEUR,
  setGrossPaidEUR,
  netPayable,
  setNetPayable,
  netPayableEUR,
  setNetPayableEUR,
  grossPayable,
  setGrossPayable,
  grossPayableEUR,
  setGrossPayableEUR,
}) => {
  useEffect(() => {
    const conv = parseFloat(conversion) || 0;
    if (conv === 0) return;

    const n1 = parseFloat(netPaid1Invoice) || 0;
    const n2 = parseFloat(netPaid2Invoice) || 0;
    const baseCostNet = parseFloat(espCostNet) || 0;

    const calcNetPaid = Number((n1 + n2).toFixed(2));
    const calcNetPaidEUR = Number((calcNetPaid / conv).toFixed(2));
    const calcGrossPaid = Number((calcNetPaid * 1.23).toFixed(2));
    const calcGrossPaidEUR = Number((calcNetPaidEUR * 1.23).toFixed(2));

    const calcNetPayable = Number((baseCostNet - calcNetPaid).toFixed(2));
    const calcNetPayableEUR = Number((calcNetPayable / conv).toFixed(2));
    const calcGrossPayable = Number((calcNetPayable * 1.23).toFixed(2));
    const calcGrossPayableEUR = Number((calcNetPayableEUR * 1.23).toFixed(2));

    if (netPaid !== calcNetPaid) setNetPaid(calcNetPaid);
    if (netPaidEUR !== calcNetPaidEUR) setNetPaidEUR(calcNetPaidEUR);
    if (grossPaid !== calcGrossPaid) setGrossPaid(calcGrossPaid);
    if (grossPaidEUR !== calcGrossPaidEUR) setGrossPaidEUR(calcGrossPaidEUR);

    if (netPayable !== calcNetPayable) setNetPayable(calcNetPayable);
    if (netPayableEUR !== calcNetPayableEUR) setNetPayableEUR(calcNetPayableEUR);
    if (grossPayable !== calcGrossPayable) setGrossPayable(calcGrossPayable);
    if (grossPayableEUR !== calcGrossPayableEUR) setGrossPayableEUR(calcGrossPayableEUR);
  }, [
    conversion,
    espCostNet,
    netPaid1Invoice,
    netPaid2Invoice,
    netPaid,
    netPaidEUR,
    grossPaid,
    grossPaidEUR,
    netPayable,
    netPayableEUR,
    grossPayable,
    grossPayableEUR,
    setNetPaid,
    setNetPaidEUR,
    setGrossPaid,
    setGrossPaidEUR,
    setNetPayable,
    setNetPayableEUR,
    setGrossPayable,
    setGrossPayableEUR,
  ]);

  return (
    <>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_net_paid}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="PLN" readOnly value={netPaid} />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_net_paid_eur}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={netPaidEUR} />
        </div>
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_gross_paid}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="PLN" readOnly value={grossPaid} />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_gross_paid_eur}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={grossPaidEUR} />
        </div>
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_net_payable}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="PLN" readOnly value={netPayable} />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_net_payable_eur}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={netPayableEUR} />
        </div>
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_gross_payable}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="PLN" readOnly value={grossPayable} />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_gross_payable_eur}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={grossPayableEUR} />
        </div>
      </div>
    </>
  );
};

export default InvoicePay;
